import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from '../../utils/axiosInstance';
import { toastError } from '../../utils/alertHelper';
const Eventview = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [event, setEvent] = useState(null);
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const fetchEvent = async () => {
    try {
      const res = await axios.get(`/api/event/${id}`);
      setEvent(res.data.event);
      setUsers(res.data.Users || []);
    } catch (error) {
      toastError('Failed to fetch event');
      navigate('/event');
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchEvent();
  }, [id]);
  if (loading) return <div className="container mt-4">Loading...</div>;
  if (!event) return <div className="container mt-4">Event not found</div>;
  return (
    <div className="container mt-4">
      <h4 className="mb-4">Scheduled Chapter Meeting</h4>
      <div className="card p-4 shadow-sm">
        <div className="row">
          <div className="col-md-6 mb-2">
            <strong>Meeting Name:</strong> {event.name}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Date:</strong> {event.startDate?.split('T')[0]}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Venue:</strong> {event.venue?.name || event.meetingVenue?.venueName || event.meetingVenue?.name || '-'}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Time:</strong> {event.formTime} To {event.endTime}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Reporting Time:</strong> {event.reportingTime || '-'}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Chapter:</strong> {event.chapter?.map(c => c.name).join(', ') || '-'}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Created by:</strong> {event.createdBy?.firstName || '-'} {event.createdBy?.lastName || ''}
          </div>
          <div className="col-md-6 mb-2">
            <strong>Notes:</strong> {event.notes || '-'}
          </div>
         {/*  <div className="col-md-6 mb-2">
                     <strong>Member Fees:</strong> ₹{event.memberFees || 'Free'}
                   </div> */}
          <div className="col-md-6 mb-2">
            <strong>Guest Fees:</strong> ₹{event.guestAllow ? event.guestFees : '-'}
          </div>
        </div>
      </div>
      <ul className="nav nav-tabs mt-4">
        <li className="nav-item">
          <span className="nav-link active">Member Attendance</span>
        </li>
      </ul>
      <div className="card p-4 shadow-sm">
        <h5 className="mb-3">Attendance</h5>
        <div className="row text-center mb-3">
          <div className="col"><strong className="text-success">{users.filter(u => u.attendanceStatus === 'present').length}</strong> Present</div>
          <div className="col"><strong className="text-danger">{users.filter(u => u.attendanceStatus === 'absent').length}</strong> Absent</div>
          <div className="col"><strong>{users.length}</strong> Total</div>
        </div>
        <div className="table-responsive">
          <table className="table table-bordered">
            <thead>
              <tr>
                <th>Member Name</th>
                <th>Mobile Number</th>
                <th>Chapter</th>
                <th>Status</th>
                <th>Present/Absent</th>
                <th>Remark</th>
              </tr>
            </thead>
           <tbody>
                {users.length > 0 ? (
                  users.map((user, index) => {
                    // Handle status and attendance
                    const status = user.comingStatus?.toLowerCase() === 'coming' ? 'coming' : 'not coming';
                    const attendance = user.attendanceStatus?.toLowerCase() === 'present' ? 'present' : 'absent';

                    return (
                      <tr key={user._id}>
                        <td>{user.firstName}</td>
                        <td>{user.mobileNumber || ''}</td>
                        <td>{user.chapter?.map(ch => ch.name).join(', ') || ''}</td>

                        {/* Coming/Not Coming badge */}
                        <td>
                          <span className={`badge ${status === 'coming' ? 'bg-success' : 'bg-danger'}`}>
                            {status.toUpperCase()}
                          </span>
                        </td>

                        {/* Present/Absent badge */}
                        <td>
                          <span className={`badge ${attendance === 'present' ? 'bg-success' : 'bg-danger'}`}>
                            {attendance.toUpperCase()}
                          </span>
                        </td>

                        <td>{user.remark || '—'}</td>
                      </tr>
                    );
                  })
                ) : (
                  <tr>
                    <td colSpan="6" className="text-center">No attendees found.</td>
                  </tr>
                )}
              </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};
export default Eventview;
